export const PMM_ADVANCED_SETTINGS_URL = '/graph/settings/advanced-settings';
